var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashTopCust(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#FFF7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7726 17.1045L14.944 19.9331C14.6941 20.1832 14.3551 20.3237 14.0016 20.3237C13.6481 20.3237 13.3091 20.1832 13.0593 19.9331L10.23 17.1045C8.14725 15.0216 8.14731 11.6448 10.2301 9.56206C12.3129 7.47931 15.6897 7.47931 17.7725 9.56206C19.8553 11.6448 19.8554 15.0216 17.7726 17.1045V17.1045",
    stroke: "#EA580C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.332C16 14.4359 15.1038 15.332 14 15.332C12.8962 15.332 12 14.4359 12 13.332C12 12.2282 12.8962 11.332 14 11.332C15.1038 11.332 16 12.2282 16 13.332V13.332",
    stroke: "#EA580C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashTopCust);
export default __webpack_public_path__ + "static/media/Dash-TopCust.204b34641dfa3e33691e5d9dfa6f669b.svg";
export { ForwardRef as ReactComponent };